module.exports = __webpack_public_path__ + "img/orange-square-table-8.e3f466c8.png";